// @davidBoyaval
export async function fetchXretry(url,options = {}, timeout, retry, id_msg = null, text = ''){
    options.headers['x-id-token'] = Date.now()+'TOURIZ'+(Math.floor(Math.random() * 99999) + 10000);
    var relance = 0;
    var essai = 1;
    const result= await fretry(url,options, timeout, retry, essai);
    console.log(result)
    if(result.msg === 'abort' || result.msg === "Accès interdit"){
        console.log(result)
        relance = 1;
        // if(id_msg !== null) {
        //     document.getElementById(id_msg).innerText = text + ' (essai n°' + '2' + ')';
        // }
    }
    while(relance === 1 && essai <= retry){
        essai ++;
        // timeout = essai * 1000;
        console.log('essai '+essai);
        // toast.info("essai n°" + (essai));
        const response = await fretry(url,options, timeout, retry, essai);
        console.log(response);
        if(response.msg === 'abort' || response.msg === "Accès interdit"){
            essai = response.retry
            if(essai === retry){
                if(id_msg !== null) {
                    document.getElementById(id_msg).style.display = "block";
                    document.getElementById(id_msg).innerText = 'La soumission de vos informations a échoué à plusieurs reprises, merci de contacter le support.';
                    return {error : "abort"};
                } else {
                    return {error : "abort"};
                }
            } else {
                if(id_msg !== null) {
                    document.getElementById(id_msg).style.display = "block";
                    document.getElementById(id_msg).innerText = text + ' (essai n°' + (essai + 1) + ')';
                } else {

                }
            }
        } else {
            relance = 0
            return response;
        }
    }
    return result
}
async function fretry(url,options = {}, timeout, retry, tentative){
    var result = '';
    try {
        const response = await fetchWithTimeout(url,options,timeout)
        result = await response.text();
        var data = 'result';
        try {
            data = JSON.parse(result); // Try to parse the response as JSON
        } catch(err) {
            data = {msg : result};
        }
        return data;
    } catch(error) {
        result = {retry : tentative,msg : 'abort'};
        return result;
    }
}
async function fetchWithTimeout(resource, options = {}, delay) {
    const { timeout = delay } = options;
    const controller = new AbortController();
    const id = setTimeout(() => controller.abort(), timeout);
    const response = await fetch(resource, {
        ...options,
        signal: controller.signal
    });
    clearTimeout(id);
    return response;
}